import useBool from '$tablet-app/src/app/utils/state/useBool';
import { VideoTutorialLocation } from '@akin-home/video-tutorials';
import React, { FC } from 'react';
import { useTutorialVideo } from '../../hooks/useTutorialVideo';
import FullScreenVideo from '../FullScreenVideo';

interface Props {
  location: VideoTutorialLocation;
  children?(params: { showVideo?(): void }): React.ReactNode;
}

const VideoAnchor: FC<Props> = (props) => {
  const { location, children } = props;
  const [video_showing, showVideo, hideVideo] = useBool();

  const { video } = useTutorialVideo({
    location,
  });

  return (
    <>
      {video ? children?.({ showVideo }) : undefined}
      {video_showing && video ? (
        <FullScreenVideo isVisible video_data={video} onClose={hideVideo} />
      ) : null}
    </>
  );
};

export default VideoAnchor;
